<template>
    <span class="nearby" :style="css" @click="click">
        <i class="iconfont icon-locate"></i>
        <span class="tip">{{ $t('nearby') }}</span>
    </span>
</template>
<script>
import { mapActions } from '@/store/helpers';

import Base from './base';
import { MAP_CHANGE_MUTATION } from '@/components/search-result/_store/types';

export default {
    mixins: [Base],
    inject: {
        defaultZoom: {
            type: Number,
            default: 13
        }
    },
    methods: {
        ...mapActions({
            "mapChangeMutation": MAP_CHANGE_MUTATION
        }),
        
        handler([map, maps, siteMap]) {
            if (window.navigator && window.navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(
                    position => {
                        siteMap.setCenter(
                            {
                                lat: position.coords.latitude,
                                lng: position.coords.longitude
                            },
                            this.defaultZoom
                        );
                        this.mapChangeMutation({
                            mapSearch: true
                        });
                    },
                    err => {
                        alert(err.message);
                    }
                );
            }
            this.$EventBus.$emit('siteTrack', {
                action: 'nearby',
                trackType: 'map-event',
                ele: this.$el
            });
        }
    }
};
</script>
<style lang="scss">
.site-map .nearby.map-tool {
    width: 30px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    background-color: #fff;
    display:flex;
    .iconfont.icon-locate{
        margin:auto;
    }
    &:hover .tip {
        display: block;
    }
}
</style>
